import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9a56458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"0.2em"} }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-pt-3 p-pl-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1rem"},
    class: "pi pi-download"
  }),
  /*#__PURE__*/_createTextVNode(" Install Medix ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "p-ml-3" }, "Please fill out all the required fields to install the app.", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "p-ml-3" }, "You need internet connection to install this app if you are installing on Local Pc.", -1))
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "p-field" }
const _hoisted_20 = {
  key: 0,
  class: "p-error"
}
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = {
  key: 0,
  class: "p-error"
}
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = { class: "p-col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showProgress)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            style: {"height":"0.2em"}
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.authenticate(!_ctx.v$.$invalid)), ["prevent"])),
          class: "p-fluid p-p-3"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              for: "name",
              class: _normalizeClass({ 'p-error': _ctx.v$.storeName.$invalid && _ctx.submitted })
            }, "Store name", 2),
            _createVNode(_component_InputText, {
              id: "storeName",
              modelValue: _ctx.v$.storeName.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.storeName.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.storeName.$invalid && _ctx.submitted }),
              autoFocus: ""
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.storeName.$invalid && _ctx.submitted) ||
              _ctx.v$.storeName.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.storeName.required.$message?.replace("Value", "Store name")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", {
              for: "name",
              class: _normalizeClass({ 'p-error': _ctx.v$.storeCode.$invalid && _ctx.submitted })
            }, "Store code", 2),
            _createVNode(_component_InputText, {
              id: "storeCode",
              modelValue: _ctx.v$.storeCode.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.storeCode.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.storeCode.$invalid && _ctx.submitted }),
              placeholder: "4 digit store code"
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.storeCode.$invalid && _ctx.submitted) ||
              _ctx.v$.storeCode.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.storeCode.required.$message?.replace("Value", "Store code")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", {
              for: "address",
              class: _normalizeClass({ 'p-error': _ctx.v$.address.$invalid && _ctx.submitted })
            }, "Address", 2),
            _createVNode(_component_InputText, {
              id: "address",
              modelValue: _ctx.v$.address.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.address.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.address.$invalid && _ctx.submitted) ||
              _ctx.v$.address.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.v$.address.required.$message?.replace("Value", "Address")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", {
              for: "userName",
              class: _normalizeClass({ 'p-error': _ctx.v$.userName.$invalid && _ctx.submitted })
            }, "User Name", 2),
            _createVNode(_component_InputText, {
              id: "userName",
              modelValue: _ctx.v$.userName.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.userName.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.userName.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.userName.$invalid && _ctx.submitted) ||
              _ctx.v$.userName.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.userName.required.$message?.replace("Value", "User name")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", {
              for: "userEmail",
              class: _normalizeClass({ 'p-error': _ctx.v$.userEmail.$invalid && _ctx.submitted })
            }, "User Email", 2),
            _createVNode(_component_InputText, {
              id: "userEmail",
              modelValue: _ctx.v$.userEmail.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.userEmail.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.userEmail.$invalid && _ctx.submitted }),
              autoFocus: ""
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.userEmail.$invalid && _ctx.submitted) ||
              _ctx.v$.userEmail.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.userEmail.required.$message?.replace("Value", "User Email")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", {
              for: "password",
              class: _normalizeClass({ 'p-error': _ctx.v$.password.$invalid && _ctx.submitted })
            }, "Password", 2),
            _createVNode(_component_InputText, {
              id: "password",
              modelValue: _ctx.v$.password.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.password.$invalid && _ctx.submitted) ||
              _ctx.v$.password.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.v$.password.required.$message?.replace("Value", "Password")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", {
              for: "purchaseCode",
              class: _normalizeClass({ 'p-error': _ctx.v$.purchaseCode.$invalid && _ctx.submitted })
            }, "Envato Purchase Key", 2),
            _createVNode(_component_InputText, {
              id: "purchaseCode",
              modelValue: _ctx.v$.purchaseCode.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.purchaseCode.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.purchaseCode.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (
              (_ctx.v$.purchaseCode.$invalid && _ctx.submitted) ||
              _ctx.v$.purchaseCode.$pending.$response
            )
              ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.v$.purchaseCode.required.$message?.replace("Value", "Purchase Key")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                class: "p-button-success",
                label: "Install",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.installApp(!_ctx.v$.$invalid)), ["prevent"])),
                icon: "pi pi-download"
              })
            ])
          ])
        ], 32)
      ])
    ])
  ], 64))
}